import React from "react";

interface LoaderProps {
  size?: "small" | "medium" | "large";
  fullScreen?: boolean;
}

const Loader: React.FC<LoaderProps> = React.memo(
  ({ size = "medium", fullScreen = false }) => {
    const sizeClasses = {
      small: "h-4 w-4",
      medium: "h-8 w-8",
      large: "h-12 w-12",
    };

    const containerClasses = fullScreen
      ? "fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50"
      : "flex items-center justify-center p-4";

    return (
      <div className={containerClasses}>
        <div
          className={`${sizeClasses[size]} animate-spin rounded-full border-4 border-gray-200 border-t-primary-default`}
        />
        {/* <svg
        className="animate-spin h-8 w-8 text-primary-default"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8z"
        ></path>
      </svg> */}
      </div>
    );
  }
);

Loader.displayName = "Loader";

export default Loader;
